import React from "react";
import Lightbox from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/counter.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";

import { IImage } from "@/types/ACFLayouts/Images";

interface LightboxProps {
  images: IImage[];
  currentIndex: number;
  setCurrentIndex: React.Dispatch<number>;
}

export function ImageLightbox({
  images,
  currentIndex,
  setCurrentIndex,
}: LightboxProps) {
  return (
    <>
      <Lightbox
        plugins={[Counter, Captions, Zoom]}
        carousel={{ finite: true, padding: "7%" }}
        captions={{ descriptionTextAlign: "center" }}
        zoom={{maxZoomPixelRatio: 2}}
        animation={{zoom: 250}}
        open={currentIndex >= 0}
        index={currentIndex}
        close={() => setCurrentIndex(-1)}
        slides={images.map((image) => {
          return {
            src: `${process.env.NEXT_PUBLIC_API_URL}${image.image.url}`,
            width: image.image.width,
            height: image.image.height,
            alt: image.image.alt,
            description: image.image.caption,
            imageFit: "contain",
          };
        })}
        styles={{
          container: { backgroundColor: "rgba(24, 24, 24, .9)" },
          captionsDescriptionContainer: {
            backgroundColor: "transparent",
            fontFamily: "__Roboto_b0d14b",
            fontSize: "1rem",
          },
        }}
        controller={{ closeOnBackdropClick: true }}
        render={{
          buttonPrev: images.length <= 1 ? () => null : undefined,
          buttonNext: images.length <= 1 ? () => null : undefined,
        }}
        noScroll={{ disabled: true }}
      />
    </>
  );
}
